export default fields =>
  fields.reduce((fieldMap, field, idx) => {
    fieldMap[field.id] = idx;
    return fieldMap;
  }, {});
